import * as Yup from 'yup'

import { Button } from '@components/Button'
import { Form, Formik } from 'formik'
import { InputField } from '@components/forms/InputField'
import { SearchIcon } from '@components/Icons'
import { BadgeSearchFormProps } from './interface'

const validationSchema = Yup.object().test((values, context) => {
  if (Boolean(values.startDate) && Boolean(!values.endDate)) {
    return context.createError({
      message: 'required',
      path: 'endDate',
    })
  }

  if (Boolean(!values.startDate) && Boolean(values.endDate)) {
    return context.createError({
      message: 'required',
      path: 'startDate',
    })
  }

  return true
})

export function BadgeSearchForm({
  initialValues,
  handleSubmit,
  handleResetSearch,
}: BadgeSearchFormProps) {
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ values, resetForm }) => (
          <Form>
            <div className='flex flex-col mt-[40px] mb-[30px]'>
              <div className='flex justify-between items-end gap-x-[10px]'>
                <div className='flex items-end gap-x-[10px] flex-1'>
                  <InputField
                    name='text'
                    placeholder='ค้นหาด้วยชื่อเรื่อง หรือ ID'
                    autoTrim={false}
                    leftIcon={<SearchIcon className='text-primary' />}
                    inputClassName='rounded-[20px] bg-blue-2 placeholder:text-blue-3 placeholder:h-[40px] '
                  />
                </div>
                <div className='flex font-mitr justify-end gap-x-[20px]'>
                  <Button
                    type='button'
                    className='text-secondary underline whitespace-pre px-0'
                    onClick={() => {
                      resetForm({
                        values: {
                          text: '',
                        },
                      })
                      handleResetSearch()
                    }}
                  >
                    ล้างค่า
                  </Button>
                  <Button type='submit' className='bg-secondary text-white '>
                    <span className='text-[14px]'>ค้นหา</span>
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
